// extracted by mini-css-extract-plugin
export var linkText = "_ou-0";